var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProvider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 7.5H12.75V4.5H11.25V7.5H8.25V9H11.25V12H12.75V9H15.75V7.5Z",
    fill: "#676767"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 7.5H19.5V3C19.4995 2.60232 19.3414 2.22105 19.0602 1.93984C18.7789 1.65864 18.3977 1.50046 18 1.5H6C5.60232 1.50046 5.22105 1.65864 4.93984 1.93984C4.65864 2.22105 4.50046 2.60232 4.5 3V7.5H3C2.60232 7.50046 2.22105 7.65864 1.93984 7.93984C1.65864 8.22105 1.50046 8.60232 1.5 9V22.5H22.5V9C22.4995 8.60232 22.3414 8.22105 22.0602 7.93984C21.7789 7.65864 21.3977 7.50046 21 7.5ZM10.5 21V16.5H13.5V21H10.5ZM15 21V15.75C15 15.5511 14.921 15.3603 14.7803 15.2197C14.6397 15.079 14.4489 15 14.25 15H9.75C9.55109 15 9.36032 15.079 9.21967 15.2197C9.07902 15.3603 9 15.5511 9 15.75V21H3V9H6V3H18V9H21V21H15Z",
    fill: "#676767"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProvider);
export default __webpack_public_path__ + "static/media/provider.e7bd45b888da7bb1bd4b229e94be3398.svg";
export { ForwardRef as ReactComponent };